<script setup lang="ts">
import { computed } from 'vue';

import Header4 from '@/components/base/typography/Header4.vue';
import type { Answer, Identifier } from '@/components/quiz/QuizWrapper.vue';

const { id, maxSelections, selectedAnswers, text } = defineProps<{
  id: Identifier;
  maxSelections?: number;
  selectedAnswers: {
    [questionId: Identifier]: Answer[];
  };
  text?: string;
}>();

const emit = defineEmits<{
  'select-answer': [
    {
      answerId: Identifier;
      maxSelections?: number;
      questionId: Identifier;
      resultMapping?: string;
    },
  ];
}>();

const selectedAnswersForQuestion = computed(
  () => selectedAnswers[id]?.map((answer) => answer.id) || [],
);

const handleSelectAnswer = ({
  answerId,
  resultMapping,
}: {
  answerId: Identifier;
  resultMapping?: string;
}) => {
  emit('select-answer', { answerId, questionId: id, maxSelections, resultMapping });
};
</script>

<template>
  <div>
    <slot name="question-header">
      <Header4>{{ text }}</Header4>
    </slot>

    <div class="flex flex-col items-center justify-center gap-3 mt-2.5">
      <slot v-bind="{ handleSelectAnswer, id, selectedAnswersForQuestion }" />
    </div>
  </div>
</template>
